// extracted by mini-css-extract-plugin
module.exports = {"form":"VoucherForm_form__29flH","button":"VoucherForm_button__3RTrl"};